import { type AppState } from 'src/redux/app/app.store'

export const selectMaintenanceNeedVehicles = (state: AppState) => state.maintenanceNeed.maintenanceNeedVehicles
